import React, { useState } from "react";

import { Recipe } from "@/client/api";
import { Badge, Input, Modal } from "@/client/components/ui/index";
import { normalize } from "@/client/utils";

export function RecipePickerModal({
  recipes,
  onPick,
  onClose,
}: {
  recipes: Recipe[];
  onPick: (recipe: Recipe) => void;
  onClose: () => void;
}) {
  const [search, setSearch] = useState("");
  const filtered = recipes.filter((r) => normalize(r.name).includes(normalize(search)));
  const byType: Record<string, Recipe[]> = {};
  for (const r of filtered) (byType[r.type ?? "other"] ??= []).push(r);
  const typeOrder = ["main", "side", "base", "dessert", "other"];
  const typeLabels: Record<string, string> = {
    main: "Principales",
    side: "Guarniciones",
    base: "Bases",
    dessert: "Postres",
    other: "Otras",
  };

  return (
    <Modal title="Agregar receta" onClose={onClose}>
      <Input
        type="search"
        value={search}
        onChange={setSearch}
        placeholder="Buscar..."
        className="mb-3"
        autoFocus
      />
      <div className="flex flex-col gap-3 max-h-80 overflow-y-auto">
        {typeOrder
          .filter((t) => byType[t]?.length)
          .map((t) => (
            <div key={t}>
              <div className="text-xs font-medium text-term-text-muted uppercase tracking-wider mb-1 px-1">
                {typeLabels[t]}
              </div>
              {byType[t]!.map((r) => (
                <button
                  key={r.id}
                  onClick={() => {
                    onPick(r);
                    onClose();
                  }}
                  className="flex items-center gap-3 px-3 py-2 rounded-lg text-left hover:bg-term-raised cursor-pointer transition-colors text-sm text-term-text w-full"
                >
                  {r.type && <Badge value={r.type} />}
                  <span className="flex-1">{r.name}</span>
                </button>
              ))}
            </div>
          ))}
        {filtered.length === 0 && (
          <p className="text-center text-sm text-term-text-muted py-4">Sin resultados</p>
        )}
      </div>
    </Modal>
  );
}
